/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-10-26 14:20:24
 * @LastEditors: susj
 * @LastEditTime: 2020-10-26 18:35:09
 */

import Page from './page';
// import { PAGE_MODE } from '@/constants/work'

class Work {
  constructor(work = {}) {
    this.id = work.id;
    this.title = work.title || '标题';
    this.isPptx = work.isPptx || '标题';
    this.pages = work.pages || [new Page()];
    // this.is_template = false;
    this.height = work.height || 900;
    this.width = work.width || 1600;
    this.schemeId = work.schemeId || null;
    this.isShare = work.isShare;
    this.organId = work.organId;
    this.isTemplate = work.isTemplate;
    this.creator = work.creator;
    this.isCollect = work.isCollect;
    this.isPptx = work.isPptx;
    // this.page_mode = work.page_mode || PAGE_MODE.SWIPPER_PAGE
  }
}

export default Work;
